import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const routeRoot = 'rentersinsurance';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;
const baseRouteV2 = `${BASE_PATH_API}/v2/${routeRoot}`;

const actions = {
    createPolicy: {
        method: 'POST',
        url: `${baseRoute}/unit/:unitId/user/:userId/insurancePolicy`
    },

    createPolicies: {
        method: 'POST',
        url: `${baseRoute}/unit/:unitId/insurancePolicies`
    },

    updatePolicy: {
        method: 'PUT',
        url: `${baseRoute}/unit/:unitId/user/:userId/insurancePolicy`
    },

    getPoliciesForUnit: {
        method: 'GET',
        url: `${baseRoute}/unit/:id/insurancePolicies`,
        params: {
            'userIds': 'userIds'
        }
    },

    deletePolicy: {
        method: 'DELETE',
        url: `${baseRoute}/unit/:unitId/user/:userId/insurancePolicy`
    },

    getAdditionalInterest: {
        method: 'GET',
        url: `${baseRoute}/additionalInterest`
    },

    saveAdditionalInterest: {
        method: 'PUT',
        url: `${baseRoute}/additionalInterest`
    },

    removeAdditionalInsured: {
        method: 'DELETE',
        url: `${baseRoute}/unit/:unitId/user/:userId/policy/:policyGuid`
    },

    getRemindersRestrictionOverride: {
        method: 'GET',
        url: `${baseRoute}/remindersRestriction`
    },

    setRemindersEnabled: {
        method: 'PUT',
        url: `${baseRoute}/remindersEnabledSetting`
    },

    getEligibility: {
        method: 'GET',
        url: `${baseRoute}/:unitId/eligibility`
    },

    getPoliciesForUnitV2: {
        method: 'GET',
        url: `${baseRouteV2}/unit/:unitId/insurancePolicies`,
        params: {
            'userIds': 'userIds'
        }
    },

    createPoliciesV2: {
        method: 'POST',
        url: `${baseRouteV2}/unit/:unitId/insurancePolicies`
    },

    updatePolicyV2: {
        method: 'PUT',
        url: `${baseRouteV2}/unit/:unitId/insurancePolicy`
    },

    updatePolicyUsers: {
        method: 'PUT',
        url: `${baseRouteV2}/policies/:guid/policyUsers`
    },

    deletePolicyV2: {
        method: 'DELETE',
        url: `${baseRouteV2}/policies/:guid`
    },

    getPolicyForTenant: {
        method: 'GET',
        url: `${baseRoute}/tenant/:tenantId/insurancePolicy`
    }
};

export function RentersInsuranceApi() {
    return createActions(actions);
}
